import "./styles/home.scss";
import ReactPlayer from "react-player";
import thumb from "./images/SeanThumb.webp";
import sean from "./images/seanbio.webp";
import logo from "./images/dealtradinglogo.webp";
import { useNavigate } from "react-router-dom";
import Testimonials from "./pages/Testimonials";
import axios from "axios";
import moment from "moment";
import { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import {
  Button,
  Stack,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import CurrencyPoundIcon from "@mui/icons-material/CurrencyPound";
import HouseIcon from "@mui/icons-material/House";
import FAQ from "./pages/FAQ";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  "@media(minWidth: 780px)": {
    width: "95%",
  },
};

export default function Home() {
  const navigate = useNavigate();
  const url = process.env.REACT_APP_API_URL;

  const [events, setEvents] = useState([]);
  const [secBackground, setSecBackground] = useState("#FFF");
  const [showNonEssential, setShowNonEssential] = useState(false);

  useEffect(() => {
    axios
      .get(`${url}/events/get-events/12`)
      .then((res) => {
        setEvents(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  // COOKIES
  const [open, setOpen] = useState(true);
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    let cookies = localStorage.getItem("pmw_cookies");
    if (cookies) {
      handleClose();
    }
  }, []);

  // !VODALYTICS
  useEffect(() => {
    (function (v, i, d, a, l, y, t, c, s) {
      y = "_" + d.toLowerCase();
      c = d + "L";
      if (!v[d]) {
        v[d] = {};
      }
      if (!v[c]) {
        v[c] = {};
      }
      if (!v[y]) {
        v[y] = {};
      }
      var vl = "Loader",
        vli = v[y][vl],
        vsl = v[c][vl + "Script"],
        vlf = v[c][vl + "Loaded"],
        ve = "Embed";
      if (!vsl) {
        vsl = function (u, cb) {
          if (t) {
            cb();
            return;
          }
          s = i.createElement("script");
          s.type = "text/javascript";
          s.async = 1;
          s.src = u;
          if (s.readyState) {
            s.onreadystatechange = function () {
              if (s.readyState === "loaded" || s.readyState == "complete") {
                s.onreadystatechange = null;
                vlf = 1;
                cb();
              }
            };
          } else {
            s.onload = function () {
              vlf = 1;
              cb();
            };
          }
          i.getElementsByTagName("head")[0].appendChild(s);
        };
      }
      vsl(l + "loader.min.js", function () {
        if (!vli) {
          var vlc = v[c][vl];
          vli = new vlc();
        }
        vli.loadScript(l + "player.min.js", function () {
          var vec = v[d][ve];
          t = new vec();
          t.run(a);
        });
      });
    })(
      window,
      document,
      "Vidalytics",
      "vidalytics_embed_GEIA0i9iUfGopMNq",
      "https://fast.vidalytics.com/embeds/MIq4bQaY/GEIA0i9iUfGopMNq/"
    );
  }, []);

  const handleCookies = () => {
    let pmw_cooks = true;

    localStorage.setItem("pmw_cookies", pmw_cooks);
    handleClose();
  };

  const handleCustomise = () => {
    setShowNonEssential(true);
  };

  function gtag() {
    window.dataLayer.push(arguments);
  }

  const handleConsent = (cookie, value) => {
    if (value == false) {
      gtag("consent", "update", {
        [cookie]: "denied",
      });
    } else {
      gtag("consent", "update", {
        [cookie]: "granted",
      });
    }
  };

  const handleDecline = async () => {
    await gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    });

    handleClose();
  };

  const scrollTo = () => {
    document.getElementById("tickets").scrollIntoView();
  };

  return (
    <main className="home__main">
      <section className="hero">
        <section className="hero__top">
          <img src={logo} alt="pmw logo" />
        </section>
        <section className="hero__content">
          <aside>
            <h2>
              Attend the UK's #1 Property Deal Trading Masterclass - Live and in
              person
            </h2>
            <h3>(For a limited time only!) </h3>
            <p>
              <strong>
                In just 2 days, we’ll show you how to find, package, and sell
                property deals for quick cashflow.{" "}
              </strong>
            </p>
            <p>
              You’ll learn the exact framework used by the UK’s most successful
              deal packagers to earn <strong>£5,000 to £10,000+</strong> per
              deal without ever buying property.
            </p>
            <p>
              It’s the fastest way to make money in property, attract serious
              investors, and finally get paid what your time is worth. 
            </p>
          </aside>
          <div className="player--wrapper">
            <div
              id="vidalytics_embed_GEIA0i9iUfGopMNq"
              style={{
                width: "100%",
                position: "relative",
                paddingTop: "56.25%",
              }}
            ></div>
            {/* <ReactPlayer
              // url="https://vimeo.com/1101805360"
              url="https://preview.vidalytics.com/oembed?url=https%3A%2F%2Fpreview.vidalytics.com%2Fvid%2FL0uLKOi4L_mLQoyf"
              controls
              style={{ aspecRatio: "16/9" }}
              className="video--player"
              // light={thumb}
              width="100%"
              height="100%"
              muted
              playing
            /> */}
            {/* <video controls className="video--player" width="50%" id="hero--vid" onClick={() => playPause()} poster={thumb} >
            <source url="https://vimeo.com/994057575/64200257f1?share=copy" type="video/mp4" />
          </video> */}
          </div>
        </section>
      </section>
      {/* Event Banner */}
      {events.length > 0 ? (
        <section className="event__banner">
          <section className="event__info">
            <section className="event-section">
              <h3>Next Event :</h3>
              <p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-calendar3"
                  viewBox="0 0 16 16"
                >
                  <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
                </svg>{" "}
                {new Date(events[0].eventDate).toLocaleDateString("en-GB")} -
                {new Date(
                  new Date(events[0].eventDate).setDate(
                    new Date(events[0].eventDate).getDate() + 1
                  )
                ).toLocaleDateString("en-GB")}
              </p>
              <p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-clock"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
                </svg>
                10am - 4.30pm
              </p>
            </section>
            <section className="event-section">
              <h3>Event location:</h3>
              <p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-geo"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.3 1.3 0 0 0-.37.265.3.3 0 0 0-.057.09V14l.002.008.016.033a.6.6 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.6.6 0 0 0 .146-.15l.015-.033L12 14v-.004a.3.3 0 0 0-.057-.09 1.3 1.3 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14"
                  />
                </svg>{" "}
                PMW HQ, 7 Cambuslang Way
                <br />
                Glasgow, G32 8ND
              </p>
            </section>
          </section>
          <button
            className="purchase__button"
            onClick={() => navigate(`/register?eventId=${events[0].eventId}`)}
          >
            Secure your place now
          </button>
          <p className="tagline">
            This is a one-time event, and it will sell out.
            <br /> Secure your place now and make sure you{" "}
            <strong>don’t miss out.</strong> 
          </p>
        </section>
      ) : null}

      {/* Text Banner */}
      <section className="info__content">
        <h3>From Zero to Cashflow in 6–12 Months</h3>
        <p>
          With over 20 years of hands-on deal trading experience, we’re sharing
          the proven framework you need to build serious cashflow and achieve
          financial freedom in the next 6 to 12 months.{" "}
        </p>

        <p>
          In fact, you’d be hard-pressed to find a successful deal sourcer who
          hasn’t learned this strategy directly from us.{" "}
        </p>

        <p>
          That alone should be reason enough to claim your place at the upcoming
          <strong> 2-Day Deal Trading Masterclass.</strong>
        </p>

        <p>But if you need more, keep reading… </p>
      </section>

      {/* How you'll get results */}
      <section className="results__content">
        <h3>What you'll walk away with & how you'll get results: </h3>
        <p>
          Whether you’re new to property or already sourcing deals, this 2-Day
          Masterclass will show you how to turn leads into{" "}
          <strong>£5,000–£10,000 plus in profit</strong> and build a compliant
          deal trading business the right way. 
        </p>

        <section className="results__checklist">
          <p>
            You’ll leave with everything you need to get started and get
            results, including how to: 
          </p>

          <div className="results__items">
            <div className="results__item">
              <CheckCircleOutlineIcon className="results__icon" />
              <p>Package deals the right way</p>
            </div>

            <div className="results__item">
              <CheckCircleOutlineIcon className="results__icon" />
              <p>Do the right due diligence</p>
            </div>

            <div className="results__item">
              <CheckCircleOutlineIcon className="results__icon" />
              <p>Attract the right investors</p>
            </div>

            <div className="results__item">
              <CheckCircleOutlineIcon className="results__icon" />
              <p>Trade deals for serious profit</p>
            </div>

            <div className="results__item">
              <CheckCircleOutlineIcon className="results__icon" />
              <p>Stay fully compliant from day one</p>
            </div>
          </div>
        </section>

        <p>
          You’ll also get{" "}
          <strong>exclusive access to our PMW investor database</strong>,
          allowing you to sell directly to a qualified network of ready buyers.{" "}
        </p>
        <p>
          There’s no faster, easier way to kickstart your property journey, or
          grow your current results. 
        </p>

        <button className="purchase__button" onClick={scrollTo}>
          Secure your place now
        </button>
      </section>

      {/* We've got you */}
      <section className="question__boxes">
        <h3>Wherever you're starting, we've got you: </h3>

        <section className="boxes__row">
          <div className="q__boxes">
            <PlayCircleOutlineIcon className="boxes__icons" />
            <h4>You're Just Getting Started? </h4>
            <p>
              If you have little to no funds, poor credit, or no clue where to
              begin, this masterclass gives you the blueprint to start from
              scratch and earn thousands per deal. 
            </p>
          </div>

          <div className="q__boxes">
            <QuestionMarkIcon className="boxes__icons" />
            <h4>Struggling to Find Deals?  </h4>
            <p>
              Our 20-year refined Deal Sourcing Blueprint reveals a proven
              step-by-step system to consistently uncover real, off-market
              property deals that others miss entirely.
            </p>
          </div>

          <div className="q__boxes">
            <CurrencyPoundIcon className="boxes__icons" />
            <h4>Looking for More Cashflow?  </h4>
            <p>
              Our students consistently earn £8,000 per deal using this powerful
              strategy — and we’ll show you how to do the same and turn deal
              sourcing into a dependable income stream.
            </p>
          </div>

          <div className="q__boxes">
            <HouseIcon className="boxes__icons" />
            <h4>Going Full-Time in Property?</h4>
            <p>
              Many of our clients go full-time within 3–6 months, replacing
              their income and building six-figure sourcing or development
              businesses. 
            </p>
          </div>
        </section>
      </section>

      {/* By the end of the event */}
      <section className="end__list">
        <h3>By the end of this 2-Day Masterclass, you will: </h3>

        <section className="list__content">
          <section className="list__left">
            <div className="list__item">
              <CheckCircleOutlineIcon className="list__icon" />
              <p>
                Have a <strong>clear, step-by-step process</strong> for
                sourcing, structuring, and trading deals 
              </p>
            </div>
            <div className="list__item">
              <CheckCircleOutlineIcon className="list__icon" />
              <p>
                Know how to set up a{" "}
                <strong>
                  fully compliant, professional deal trading business
                </strong>
              </p>
            </div>
            <div className="list__item">
              <CheckCircleOutlineIcon className="list__icon" />
              <p>
                Master the art of
                <strong> due diligence and refurb pricing</strong> 
              </p>
            </div>
          </section>

          <section className="list__right">
            <div className="list__item">
              <CheckCircleOutlineIcon className="list__icon" />
              <p>
                Gain <strong>unshakeable confidence</strong> in your ability to
                succeed in property sourcing
              </p>
            </div>
            <div className="list__item">
              <CheckCircleOutlineIcon className="list__icon" />
              <p>
                Understand how to{" "}
                <strong>attract high-quality investors</strong> who are ready to
                work with you 
              </p>
            </div>
            <div className="list__item">
              <CheckCircleOutlineIcon className="list__icon" />
              <p>
                Be able to <strong>find off-market deals</strong> and turn them
                into serious profit
              </p>
            </div>
          </section>
        </section>

        <p className="tag">
          And All This… <br />
          For Just £997 + VAT? 
        </p>
        <h3 className="catch__heading">What's the catch?</h3>
        <section className="catch__desc">
          <section className="catch__left">
            <p className="catch__header">There isn't one.</p>
            <p>
              Paul McFadden became a property millionaire by age 26. Over two
              decades, he’s personally traded more deals than almost anyone in
              the game, and built one of the most successful property training
              companies in the UK, based on real results.{" "}
            </p>

            <p>
              At a time when the market is tough and uncertainty is high, Paul’s
              decided to do what no one else is doing:{" "}
            </p>

            <p>
              <strong>
                Make this life-changing strategy available for less than fifty
                quid.{" "}
              </strong>
            </p>

            <p>Why?</p>

            <p>
              Because this is the strategy that started it all for Paul, and for
              hundreds of others. And now it’s your turn.{" "}
            </p>
          </section>

          <section className="catch__right">
            <p className="catch__header">But That’s Not All… </p>
            <p>
              There’s a very real opportunity for you to{" "}
              <strong>partner with us.</strong>
            </p>

            <p>
              We fund deals. We joint venture. And we’ll give you access to our
              trusted investor list, so you have a real chance to succeed right
              away.
            </p>

            <p>
              This isn’t just training, it’s a chance to launch a new income
              stream, backed by people who’ve done it at scale.
            </p>

            <p>
              But this offer is <strong>time-sensitive.</strong>{" "}
            </p>

            <p>
              We don’t run these events often, and certainly not at this price. 
            </p>
          </section>
        </section>
        <button className="purchase__button" onClick={scrollTo}>
          Secure your place now
        </button>
      </section>

      <section className="ticket__area" id="tickets">
        <h3>Your move </h3>
        {/* //! UNCOMMENT BELOW WHEN TICKETS ARE GOING ON SALE */}
        {/* <p>
          Secure your place at the 2-Day Property Deal Trading Masterclass now
          for just £997 + VAT. <br />
          <strong>
            Spaces are limited. Opportunities like this don’t come often.{" "}
          </strong>
          <br />
          Click below and book your place. 
        </p> */}
        {/* //! ONLY USE BELOW WHEN NO TICKETS ARE CURRENTLY AVAILABLE */}
        <p>
          Tickets for the 2-Day Property Deal Trading Masterclass are not yet on
          sale. <br />
          <strong>
            Check back soon to secure your place when tickets become available!{" "}
          </strong>
          <br />
          Don’t miss out, spaces are limited.
        </p>

        <section className="ticket__cards">
          {events.map((event) => {
            let location = (
              <>
                PMW HQ, 7 Cambuslang Way
                <br />
                Glasgow, G32 8ND
              </>
            );
            let date = `${moment(event.eventDate).format(
              "dddd, Do MMMM"
            )} & ${moment(event.eventDate)
              .add(1, "day")
              .format("dddd, Do MMMM")}`;
            let now = moment();
            let eventStart = moment(event.eventDate)
              .hour(10)
              .minute(0)
              .second(0);
            let button;
            if (now.isAfter(eventStart)) {
              button = (
                <button className="purchase__button" disabled>
                  Event has started
                </button>
              );
            } else {
              button = (
                <button
                  className="purchase__button"
                  onClick={() =>
                    navigate(`/register?eventId=${events[0].eventId}`)
                  }
                >
                  Secure your place now
                </button>
              );
            }
            return (
              <div className="ticket__info">
                <p className="date">{date}</p>
                <hr />
                <p className="price">Only £49</p>

                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-geo"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.3 1.3 0 0 0-.37.265.3.3 0 0 0-.057.09V14l.002.008.016.033a.6.6 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.6.6 0 0 0 .146-.15l.015-.033L12 14v-.004a.3.3 0 0 0-.057-.09 1.3 1.3 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14"
                    />
                  </svg>{" "}
                  {location}
                </p>
                {button}
              </div>
            );
          })}
        </section>
      </section>

      {/* Testimonials */}
      <Testimonials background={secBackground} />

      {/* Host */}
      <section className="host__content">
        <section className="host__bio">
          <section className="host__left">
            <img src={sean} className="bio__image" alt="testimonial image" />
          </section>
          <section className="host__right">
            <h5>Meet your trainer: Sean McIntyre</h5>
            <p>
              This is the{" "}
              <strong>
                exact framework Paul McFadden used to build his successful
                property business
              </strong>{" "}
              and help hundreds of people become profitable deal sourcers across
              the UK.{" "}
            </p>
            <p>
              Now, as Paul’s business partner,{" "}
              <strong>
                Sean McIntyre leads the deal trading side of the business and
                will be your trainer for this 2-Day Masterclass.{" "}
              </strong>
            </p>
            <p>
              Sean was trained directly by Paul and works on live deals every
              day. He knows exactly what works and how to help others do the
              same.{" "}
            </p>
            <p>
              Over 2 days, he’ll walk you through the{" "}
              <strong>
                simple, step-by-step framework to help you start, grow, and make
                money from deal trading, fast.
              </strong>
               
            </p>
          </section>
        </section>
      </section>
      {/* FAQs */}
      <FAQ background={secBackground} />
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: {
              xs: "90vw", // mobile
              sm: "80vw",
              md: "50vw",
              lg: "40vw",
            },
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            We Use Cookies
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            We use cookies to ensure the best experience on our website. These
            help us improve our site performance, personalise content, and
            deliver targeted ads.
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            By clicking "Accept All Cookies," you agree to the use of all
            cookies. You can manage your preferences by selecting "Customise
            Settings" or view our full Cookie Policy for more information.
          </Typography>
          {showNonEssential ? (
            <Stack>
              <FormGroup>
                <FormControlLabel
                  disabled
                  control={<Switch defaultChecked />}
                  label="Essential Cookies"
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Performance Cookies"
                  onChange={(e) =>
                    handleConsent("performance", e.target.checked)
                  }
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Functionality Cookies"
                  onChange={(e) =>
                    handleConsent("ad_personalization", e.target.checked)
                  }
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Analytics Cookies"
                  onChange={(e) =>
                    handleConsent("analytics_storage", e.target.checked)
                  }
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Adverstising Cookies"
                  onChange={(e) =>
                    handleConsent("ad_storage", e.target.checked)
                  }
                />
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label="Social Media Cookies"
                  onChange={(e) =>
                    handleConsent("ad_user_data", e.target.checked)
                  }
                />
              </FormGroup>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={2}
                sx={{ marginTop: "5%" }}
              >
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleCookies}
                >
                  Accept Custom
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  onClick={handleCookies}
                >
                  Accept All
                </Button>
              </Stack>
            </Stack>
          ) : (
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              sx={{ marginTop: "5%" }}
            >
              <Button
                variant="outlined"
                color="success"
                onClick={handleCookies}
              >
                Accept Cookies
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCustomise}
              >
                Customise Settings
              </Button>
              <Button
                variant="outlined"
                color="success"
                onClick={handleDecline}
              >
                Decline Non-Essential
              </Button>
            </Stack>
          )}
        </Box>
      </Modal>
    </main>
  );
}
